import _ from "lodash";
import AuthService from "./AuthService/AuthService";
import { isExpired } from "react-jwt";
import { handleError } from "../model/handleError";

const {REACT_APP_REST_ENDPOINT} = process.env;



const defaultConfig = {
    mode: 'cors', // no-cors, *cors, same-origin
    headers: {"Content-Type": "application/json"},
};

const refreshTokenIfExpired = async () => {
    const token = localStorage.getItem("token");
    if (token && isExpired(token)) {
        try {
            const responseRefreshToken = await AuthService.refreshToken();
            localStorage.setItem("token", responseRefreshToken.access_token);
            localStorage.setItem("refresh_token", responseRefreshToken.refresh_token);
        } catch (error) {
            handleError(error);
        }
     }
}

export default class ApiService {
        
    static getAuthHeader = async () => {
        try {
            const token = localStorage.getItem("token");
            if (token) {
                return {
                    headers: {
                        ...defaultConfig?.headers,
                        Authorization: `Bearer ${token}`,
                    },
                };
            }
        } catch (error) {
            console.error(error);
        }
    };

    static getAuthRefreshTokenHeader = async () => {
        try {
            const token = localStorage.getItem("refresh_token");
            if (token) {
                return {
                    headers: {
                        ...defaultConfig?.headers,
                        Authorization: `Bearer ${token}`,
                    },
                };
            }
        } catch (error) {
            console.error(error);
        }
    };

    static refreshTokenRequest = async (
        resolve,
        reject,
        url,
        data,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        let config = {
            method: "POST",
            body: JSON.stringify(data),
            ...defaultConfig,
            ...(await this.getAuthRefreshTokenHeader()),
        };

        config = _.merge(config, additionalConfig);

        fetch(url, config)
            .then(async (response) => {
                if (!response.ok) {
                    const data = await response.json();
                    if(data?.error === "Nessun token trovato con l'ID specificato") {
                        localStorage.removeItem("token");
                        localStorage.removeItem("refresh_token");
                        window.location.reload();
                    }
                    reject(data);
                    return;
                }
                return response.json();
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };

    // static postRequest = async (
    //     resolve,
    //     reject,
    //     url,
    //     data,
    //     isFormData = false,
    //     additionalConfig = {}
    // ) => {
    //     if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
    //         console.error("REACT_APP_REST_ENDPOINT not defined");
    
    //     await refreshTokenIfExpired();
    
    //     let headers = {};
    //     let body;
    
    //     if (isFormData) {
    //         body = data; // FormData deve essere passato direttamente
    //         const authHeader = await this.getAuthHeader();
    //         headers = {
    //             ...authHeader.headers
    //             // NON includere Content-Type, FormData se lo gestisce da solo
    //         };
    //     } else {
    //         body = JSON.stringify(data);
    //         headers = {
    //             ...(await this.getAuthHeader()).headers,
    //             "Content-Type": "application/json"
    //         };
    //     }
    
    //     let config = {
    //         method: "POST",
    //         body,
    //         headers,
    //         ...additionalConfig
    //     };
    
    //     // Debug opzionale
    //     // console.log("POST config:", config);
    
    //     fetch(url, config)
    //         .then(async (response) => {
    //             if (!response.ok) {
    //                 let errorData = await response.json();
    //                 return reject(errorData);
    //             }
    //             return response.json();
    //         })
    //         .then(resolve)
    //         .catch(reject);
    // };

    static postRequest = async (
        resolve,
        reject,
        url,
        data,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        await refreshTokenIfExpired();
        let config = {
            method: "POST",
            body: JSON.stringify(data),
            ...defaultConfig,
            ...(await this.getAuthHeader()),
        };

        config = _.merge(config, additionalConfig);

        fetch(url, config)
            .then(async (response) => {
                if (!response.ok) {
                    const data = await response.json();
                    reject(data);
                    return;
                }
                return response.json();
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };

    
    static postNoAuthRequest = async (
        resolve,
        reject,
        url,
        data,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        let config = {
            method: "POST",
            body: JSON.stringify(data),
            ...defaultConfig,
        };

        config = _.merge(config, additionalConfig);

        fetch(url, config)
            .then(async (response) => {
                if (!response.ok) {
                    const data = await response.json();
                    reject(data);
                    return;
                }
                return response.json();
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };

    static postRudeRequest = async (
        resolve,
        reject,
        url,
        data,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        await refreshTokenIfExpired();
        let config = {
            method: "POST",
            body: JSON.stringify(data),
            ...defaultConfig,
            ...(await this.getAuthHeader()),
        };

        config = _.merge(config, additionalConfig);

        fetch(url, config)
            .then(async (response) => {
                if (!response.ok) {
                    let data = await response.json();
                    reject(data); 
                };
                return response;
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };

    static delete = async (
        resolve,
        reject,
        url,
        data,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        await refreshTokenIfExpired();    
        let config = {
            method: "DELETE",
            body: JSON.stringify(data),
            ...defaultConfig,
            ...(await this.getAuthHeader()),
        };

        config = _.merge(config, additionalConfig);

        fetch(url, config)
            .then(async (response) => {
                if (!response.ok) {
                    let data = await response.json();
                    reject(data); 
                };
                return response;
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };


    static putRequest = async (
        resolve,
        reject,
        url,
        data,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        await refreshTokenIfExpired();     
        let config = {
            method: "PUT",
            body: JSON.stringify(data),
            ...defaultConfig,
            ...(await this.getAuthHeader()),
        };

        config = _.merge(config, additionalConfig);
        fetch(url, config)
        .then(async (response) => {
            if (!response.ok) {
                const data = await response.json();
                reject(data);
                return;
            }
            return response.json();
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
            // .then(async (response) => {
            //     if (!response.ok) {
            //         let result = await response.json();
            //         if (response.status === 400) {
            //             response.reject = result;
            //             reject(response)
            //         } else {
            //             reject(response)
            //         }

            //     }
            //     ;
            //     return response?.json();
            // })
    };

    static getRequest = async (resolve, reject, url, additionalConfig = {}) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "") {
            console.error("REACT_APP_REST_ENDPOINT not defined");
        }

        await refreshTokenIfExpired(); 
        let config = {
            ...this.defaultConfig,
            ...(await this.getAuthHeader()),
            method: "GET",
        };

        config = _.merge(config, additionalConfig);

        fetch(url, config)
            .then(async (response) => {
                if (!response.ok) {
                    const result = await response.json();
                    if (response.status === 400) {
                        response.reject = result;
                        reject(response);
                    } else {
                        reject(response);
                    }
                    return;
                }
                return response.json();
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };

    static getTextRequest = async (resolve, reject, url, additionalConfig = {}) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "") {
            console.error("REACT_APP_REST_ENDPOINT not defined");
        }

        await refreshTokenIfExpired(); 
        let config = {
            ...this.defaultConfig,
            ...(await this.getAuthHeader()),
            method: "GET",
        };

        config = _.merge(config, additionalConfig);

        fetch(url, config)
            .then(async (response) => {
                if (!response.ok) {
                    let result = await response.text();
                    if (response.status === 400) {
                        response.reject = result;
                        reject(response);
                    } else {
                        reject(response);
                    }
                }

                return response?.text();
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };

    static getRudeRequest = async (url, additionalConfig = {}) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "") {
            console.error("REACT_APP_REST_ENDPOINT not defined");
        }

        await refreshTokenIfExpired();

        let config = {
            ...this.defaultConfig,
            ...(await this.getAuthHeader()),
            method: "GET",
        };

        config = _.merge(config, additionalConfig);

        const response = await fetch(url, config);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ status: response.status }));
            const err = { ...errorData, status: response.status };
            handleError(err);
            return Promise.reject(err);
        }
        return response;
    };


    static getNoAuthRequest = async (
        resolve,
        reject,
        url,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        let config = {
            method: "GET",
        };

        fetch(url, config)
            .then((response) => {
                if (!response.ok) reject(response?.status);
                return response.json();
            })
            .then((data) => resolve(data))
            .catch((error) => reject(error));
    };

    static deleteRequest = async (
        resolve,
        reject,
        url,
        additionalConfig = {}
    ) => {
        if (!REACT_APP_REST_ENDPOINT || REACT_APP_REST_ENDPOINT === "")
            console.error("REACT_APP_REST_ENDPOINT not defined");

        await refreshTokenIfExpired(); 
        let config = {
            ...this.defaultConfig,
            ...(await this.getAuthHeader()),
            method: "DELETE",
        };

        config = _.merge(config, additionalConfig);

        let response = fetch(url, config)

        return response.json
    };

    static postFormData(url, formData) {
        return fetch(url, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            if (data.error) {
                throw new Error(data.error);
            }
            return data;
        });
    }

    static postRequestWithDownload(resolve, reject, url, data) {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (response.ok) {
                return response.blob();
            }
            throw new Error('Network response was not ok.');
        })
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = data?.filename || 'statino.pdf';     
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            resolve();
        })
        .catch(error => reject(error));
    }

}
